export { Slot, Slottable } from '@radix-ui/react-slot';
